import { Icon, Popup } from "semantic-ui-react";

import { Images, Videos } from "components";
import "modules/LeadsDashboard/components/MediaPreview/MediaPreview.scss";

import type { DealerLocation, QuestionResultImage, QuestionResultVideo } from "models";

type Props = {
  images?: QuestionResultImage[];
  videos?: QuestionResultVideo[];
  location?: DealerLocation | null;
};

export const MediaPreview = ({ images, videos, location }: Props) => {
  if (!images && !videos) return null;

  const mediaNumber = (images?.length ?? 0) + (videos?.length ?? 0);
  return (
    <Popup
      on="click"
      hideOnScroll
      content={
        <div className="media-preview-container">
          <Images images={images} />
          <Videos videos={videos} location={location} />
        </div>
      }
      trigger={
        <div className="media-preview-question-result ">
          <div>
            <Icon className="film photo media-preview-question-result-icon" />
          </div>
          <div className="media-preview-question-text-container">
            <span className="media-preview-question-text"> {mediaNumber} </span>
          </div>
        </div>
      }
    />
  );
};
